@if (edit) {
    <clp-toolbar [title]="('course.update.title' | translate)"></clp-toolbar>
}
@else {
    <clp-toolbar [title]="('course.create.title' | translate)"></clp-toolbar>
}

<div class="px-4 py-3">
  <div class="mx-auto w-full max-w-7xl">
    <section class="rounded-xl border border-slate-700 bg-slate-900/40 p-2 sm:p-3">
      <clp-course-progress-bar
        [currentStep]="stepNumber"
        [stepLabels]="stepLabels"
        (nextStep)="moveNext()"
        (previousStep)="movePrevious()">
      </clp-course-progress-bar>
    </section>

    <section class="mt-2 pt-2">
      <div [class.hidden]="stepNumber !== 1">
        <clp-course-general-data [section]="'all'"></clp-course-general-data>
      </div>

      <div [class.hidden]="stepNumber !== 2">
        <clp-course-module-data></clp-course-module-data>
      </div>
      <div [class.hidden]="stepNumber !== 3">
        <clp-course-lesson-data [courseId]="courseId"></clp-course-lesson-data>
      </div>
      <div [class.hidden]="stepNumber !== 4">
        <clp-course-review></clp-course-review>
      </div>
    </section>
  </div>
</div>

